export const RoutePath = {
  About: '/about',
  AddOrganization: '/add-organization',
  Map: '/map',
  Table: '/table',
  Form: '/form',
}
export const MOBILE_WIDTH = 640
export const MAP_WIDTH = 975
export const MAP_ASPECT_RATIO = 1.598

export const STRATEGY_PARENT_OPTIONS = ['strategy:narrative', 'strategy:policy']
export const TARGET_PARENT_OPTIONS = [
  'target:government',
  'target:institutions',
]

export const Color = {
  White: '#e9e7e1',
  Black: '#222222',
  LightBlack: '#2C2C2C',
  Red: '#db5541',
  Teal: '#4ca1b1',
  Orange: '#da9b28',
  Green: '#629a41',
  Brown: '#C6815A',
  Yellow: '#F8CF40',
}
